import type * as React from 'react';

import { cn } from '@nesso/ui/lib/utils';
import { ToggleGroupItem } from '@nesso/ui/primitives/toggle-group';

type Props = React.ComponentPropsWithoutRef<typeof ToggleGroupItem>;

export function EditSessionNoteSettingsToggleItem({ className, size, variant, ...props }: Props) {
    return (
        <ToggleGroupItem
            size={size ?? 'sm'}
            variant={variant ?? 'outline'}
            className={cn('flex-1 px-1.5 py-2.5 text-sm bg-background font-normal', className)}
            {...props}
        />
    );
}
